import { render, staticRenderFns } from "./RMHistoryList.vue?vue&type=template&id=f14fa24a"
import script from "./RMHistoryList.vue?vue&type=script&lang=js"
export * from "./RMHistoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports